import { normaliseError, postJson } from './http';
import { showToast } from './toast';

function findSubmitButton(form) {
    return form.querySelector(
        'button[type="submit"], button:not([type])'
    );
}

function setButtonLoading(button) {
    if (!button) {
        return;
    }

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');

    button.innerHTML = `
        <span
            class="spinner-border spinner-border-sm"
            aria-hidden="true"
        ></span>
        <span>Instellen…</span>
    `;
}

function restoreButton(button, originalHtml) {
    if (!button) {
        return;
    }

    button.innerHTML = originalHtml;
    button.disabled = false;
    button.removeAttribute('aria-busy');
}

function getErrorRegion(form) {
    let errorRegion = form.querySelector('[data-stock-error]');

    if (errorRegion) {
        return errorRegion;
    }

    errorRegion = document.createElement('div');
    errorRegion.className = 'v2-inline-error';
    errorRegion.dataset.stockError = '';
    errorRegion.setAttribute('role', 'alert');
    errorRegion.setAttribute('aria-live', 'assertive');
    errorRegion.hidden = true;

    form.appendChild(errorRegion);

    return errorRegion;
}

function clearError(form) {
    const errorRegion = form.querySelector('[data-stock-error]');

    if (!errorRegion) {
        return;
    }

    errorRegion.textContent = '';
    errorRegion.hidden = true;
}

function showError(form, message) {
    const errorRegion = getErrorRegion(form);

    errorRegion.textContent = message;
    errorRegion.hidden = false;
}

async function handleStockNotification(event) {
    const form = event.target.closest('[data-stock-notification]');

    if (!form) {
        return;
    }

    event.preventDefault();

    if (form.dataset.submitting === 'true') {
        return;
    }

    const button = findSubmitButton(form);
    const originalHtml = button?.innerHTML || '';

    const payload = {
        email: form.querySelector('[name="email"]')?.value || '',
    };

    const productKey =
        form.dataset.kind === 'card'
            ? 'card_id'
            : 'noncard_id';

    payload[productKey] = Number(form.dataset.id);

    form.dataset.submitting = 'true';

    clearError(form);
    setButtonLoading(button);

    try {
        await postJson(form.action, payload);

        form.innerHTML = `
            <div class="v2-inline-success" role="status">
                <i
                    class="bi bi-check-circle-fill"
                    aria-hidden="true"
                ></i>
                Je ontvangt een e-mail zodra dit product weer op voorraad is.
            </div>
        `;
    } catch (error) {
        const message = normaliseError(error);

        showError(form, message);
        showToast(message, 'error');

        restoreButton(button, originalHtml);
        form.dataset.submitting = 'false';
    }
}

export function initialiseStockNotifications() {
    document.addEventListener('submit', handleStockNotification);
}